import type {Pinia} from 'pinia';
import {callOnce, defineNuxtPlugin, useAsyncData, useAuth, useLocale, useMaltVisitorId, useRuntimeConfig} from '#imports';

export default defineNuxtPlugin({
    name: 'fetch-auth',
    dependsOn: ['backend-api-cookies'],
    async setup(nuxtApp) {
        const $pinia = nuxtApp.$pinia as Pinia;
        const runtimeConfig = useRuntimeConfig();
        const useCurrentSession = runtimeConfig.public['@malt/nuxt-auth-module']?.useCurrentSession ?? false;

        if (useCurrentSession) {
            const authStore = useAuth($pinia);
            const maltVisitorId = useMaltVisitorId();
            const {updateLocale} = useLocale();

            await callOnce('current-session', async () => {
                await authStore.checkIfLoggedOrIfNeedingRedirect();

                if (authStore.userVisitorId) {
                    maltVisitorId.value = authStore.userVisitorId;
                }

                if (authStore.userLocale) {
                    updateLocale(authStore.userLocale);
                }
            });
        } else {
            const {isLogged} = useAuth($pinia);

            await nuxtApp.runWithContext(
                async () =>
                    await useAsyncData(
                        'isLogged',
                        async () => {
                            return {
                                isLogged: await isLogged(),
                            };
                        },
                        {dedupe: 'defer'},
                    ),
            );
        }

        return {
            provide: {
                isPluginFetchCurrentSessionEnabled: useCurrentSession,
            },
        };
    },
});
